export default function getMinMembers(community) {
  return {
    test: 2,
    "fll-brasil": 2,
    "ftc-brasil": 2,
    "frc-brasil": 4,
    "f1-brasil": 2,
    desafiocovid: 2,
    desafiorelampago: 4,
    "fll-open-brazil": 2,
    "off-season-sesi-mt": 2,
  }[community];
}



// WEBPACK FOOTER //
// ./src/helpers/events/getMinMembers.js